import { ProcessStatus, Transaction } from '../../interfaces/ImportHistory';
import axios from 'axios';
import { sanitizeFilename } from './securityHelpers';

const formatDate = (date: Date): string =>
	(date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
	'/' +
	(date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
	'/' +
	date.getFullYear();

const formatDateHoursMinutes = (date: Date): string =>
	formatDate(date) +
	' - ' +
	(date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
	':' +
	(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
const mapColumnIdToName = ['startDate', 'fileName', 'fullStatus', 'source', 'queuedTransactions'];

export const getSortByColumnName = (columnId: number) => mapColumnIdToName[columnId - 1];

export const customComponentColumns = [
	{
		id: 1,
		title: 'Date',
		dataKey: 'startDate',
		component: ({ content }: { content: Transaction }) => formatDateHoursMinutes(new Date(content.startDate)),
	},
	{
		id: 2,
		title: 'File Name',
		dataKey: 'fileName',
	},
	{
		id: 3,
		title: 'Status',
		dataKey: 'fullStatus',
	},
	{
		id: 4,
		title: 'Source',
		dataKey: 'source',
	},
	{
		id: 5,
		title: 'Transactions',
		dataKey: 'transactions',
	},
];

export const formatShortDate = (date: Date) =>
	date.getFullYear() + '-' + (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1));

export const downloadPDF = (pdfLink: string, pdfName: string): void => {
	axios({
		url: pdfLink,
		method: 'GET',
		responseType: 'blob',
	}).then(response => {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;
		// Sanitize filename to prevent XSS attacks (CWE-80)
		// Use detached element click to avoid appendChild DOM sink
		link.download = sanitizeFilename(pdfName);
		link.click();
		window.URL.revokeObjectURL(url);
	});
};

export const getStatusStringFromCode = (allProcessStatus: ProcessStatus[], codeStatus: string): string => {
	const itemStatusMatchCode = allProcessStatus.find(item => item.id.toString() === codeStatus);
	return itemStatusMatchCode?.status ?? '';
};

export const getCodeFromStringValue = (allProcessStatus: ProcessStatus[], strStatus: string): string => {
	const itemStatusMatchString = allProcessStatus.find(itemStatus => itemStatus.status === strStatus);
	return itemStatusMatchString ? itemStatusMatchString.id.toString() : '';
};
